export default __webpack_public_path__ + "static/media/preview-video-2.0eb5e371.jpg";